import React, { useEffect, useState } from 'react';
import './Header.css';
import logooficial from '../assets/images/norea.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faBell } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { useNavigate } from 'react-router-dom';

function Header({ handleLogout }) {
  const [userInfo, setUserInfo] = useState({ nome: '', logo: '' });

  const [waStatus, setWaStatus] = useState({
    whatsapp_ativo: 0,
    connected: null,
    paymentStatus: null,
    loading: true,
  });

  const navigate = useNavigate();

  // =========================
  // USER INFO
  // =========================
  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const response = await fetch('https://welaunchyou.com.br/crm-wly/getUserInfo.php', {
          credentials: 'include',
        });

        if (!response.ok) {
          console.error('Erro ao buscar informações do usuário:', response.statusText);
          return;
        }

        const data = await response.json();
        const avatarPath = data.logo
          ? `https://welaunchyou.com.br/crm-wly/${data.logo.replace(/\\/g, '/')}`
          : '';

        setUserInfo({ ...data, logo: avatarPath });
      } catch (error) {
        console.error('Erro ao buscar informações do usuário:', error);
      }
    };

    fetchUserInfo();
  }, []);

  // =========================
  // WHATSAPP STATUS (polling)
  // =========================
  useEffect(() => {
    let alive = true;
    let timer = null;

    const fetchWaStatus = async () => {
      try {
        const res = await fetch('/crm-wly/api/whatsapp/status_instancia.php', {
          credentials: 'include',
          cache: 'no-store',
        });

        if (!res.ok) {
          if (alive) setWaStatus((s) => ({ ...s, loading: false }));
          return;
        }

        const data = await res.json();
        if (!alive) return;

        setWaStatus({
          whatsapp_ativo: Number(data?.whatsapp_ativo || 0),
          connected: typeof data?.connected === 'boolean' ? data.connected : null,
          paymentStatus: data?.paymentStatus ?? null,
          loading: false,
        });
      } catch (e) {
        if (alive) setWaStatus((s) => ({ ...s, loading: false }));
      }
    };

    fetchWaStatus();
    timer = setInterval(fetchWaStatus, 30000);

    return () => {
      alive = false;
      if (timer) clearInterval(timer);
    };
  }, []);

  
  const handleNotificationClick = () => {
    alert('Sem notificações');
  };

  // =========================
  // RENDER WA STATUS + TOOLTIP
  // =========================
  const renderWaStatus = () => {
    if (waStatus.loading) return null;
    if (waStatus.whatsapp_ativo !== 1) return null;

    const paymentUpper = String(waStatus.paymentStatus || '').toUpperCase();
    const isCanceled =
      paymentUpper === 'CANCELED' ||
      paymentUpper === 'CANCELLED' ||
      paymentUpper === 'CANCELLATION_PROCESS';

    let statusClass = 'wa-status-off';
    let statusLabel = 'Desconectado';

    if (isCanceled) {
      statusClass = 'wa-status-canceled';
      statusLabel = 'Cancelado';
    } else if (waStatus.connected === true) {
      statusClass = 'wa-status-on';
      statusLabel = 'Conectado';
    } else if (waStatus.connected === false) {
      statusClass = 'wa-status-off';
      statusLabel = 'Desconectado';
    }

    return (
      <div className={`wa-status ${statusClass}`}>
       <FontAwesomeIcon
  icon={faWhatsapp}
  className="wa-icon"
  title={`WhatsApp ${statusLabel}`}
  onClick={() => navigate("/wzp/painel-mensagens")}
  style={{ cursor: "pointer" }}
/>
        <span className="wa-indicator" title={`WhatsApp ${statusLabel}`}></span>
      </div>
    );
  };

  return (
    <header className="header">
      <div className="header-content">
        <img src={logooficial} alt="Logo Nórea CRM" className="logooficial" />
        <h1 className="header-title">CRM</h1>
      </div>

      <div className="header-user-actions">
        {userInfo.logo && (
          <div className="header-avatar-wrap">
            <div className="header-avatar">
              <img src={userInfo.logo} alt={`Avatar de ${userInfo.nome}`} className="avatar" />
            </div>

            {renderWaStatus()}
          </div>
        )}

        <FontAwesomeIcon
          icon={faBell}
          className="notification-icon"
          title="Notificações"
          onClick={handleNotificationClick}
        />

        <FontAwesomeIcon
          icon={faSignOutAlt}
          className="logout-icon"
          title="Sair"
          onClick={handleLogout}
        />
      </div>
    </header>
  );
}

export default Header;